"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarWrapper = exports.Toolbar = exports.ToolContent = exports.StyledNoteHeader = exports.StyledFadingOverflow = exports.Fader = exports.Content = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../../../styles/palette");
var _FadingOverflow = _interopRequireDefault(require("../../../FadingOverflow"));
var _formattedText = require("../../../../styles/formatted-text");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var toolbarHeight = '3rem';
var ToolContent = exports.ToolContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__ToolContent",
  componentId: "sc-1cowzbx-0"
})(["position:absolute;top:0;left:0;right:0;bottom:", ";overflow:hidden;"], toolbarHeight);
var StyledFadingOverflow = exports.StyledFadingOverflow = (0, _styledComponents["default"])(_FadingOverflow["default"]).withConfig({
  displayName: "styles__StyledFadingOverflow",
  componentId: "sc-1cowzbx-1"
})(["background:#ffffff;position:absolute;bottom:0;left:0;right:0;margin-top:2rem;max-height:calc(100% - 1rem);"]);
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1cowzbx-2"
})(["padding:1.5rem 2rem;word-wrap:break-word;p{line-height:1.5rem;margin:0 0 1.5rem 0;&:last-child{margin-bottom:0;}}h4{font-weight:bold;}", ""], (0, _formattedText.getFormattedTextStyle)(true));
var ToolbarWrapper = exports.ToolbarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ToolbarWrapper",
  componentId: "sc-1cowzbx-3"
})([".example-enter{.fader{opacity:0;}.content{bottom:-40px;}}.example-enter.example-enter-active{.fader{opacity:1;transition:150ms;}.content{bottom:0;transition:150ms;}}.example-leave{.fader{opacity:1;transition:150ms;}.content{opacity:1;bottom:0px;}}.example-leave.example-leave-active{.fader{opacity:0;transition:150ms;}.content{opacity:0;bottom:-40px;transition:150ms;}}"]);
var Toolbar = exports.Toolbar = _styledComponents["default"].div.withConfig({
  displayName: "styles__Toolbar",
  componentId: "sc-1cowzbx-4"
})(["display:flex;flex-direction:row;height:", ";> div{flex:1;min-width:0px;}"], toolbarHeight);
var Fader = exports.Fader = _styledComponents["default"].div.withConfig({
  displayName: "styles__Fader",
  componentId: "sc-1cowzbx-5"
})(["background:rgba(0,0,0,0.1);position:absolute;top:0;left:0;right:0;bottom:0;"]);
var StyledNoteHeader = exports.StyledNoteHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledNoteHeader",
  componentId: "sc-1cowzbx-6"
})(["background:", ";color:white;padding:0.25rem 2rem;font-size:0.7rem;"], _palette.commonPalette.orange);
//# sourceMappingURL=styles.js.map